import * as React from 'react';
import * as tzUtils from '../../../utils/TimezoneUtils';
import { useTranslation } from 'react-i18next';
import { FloatingDropdown } from 'wix-ui-tpa';
import ManuTimezoneIcon from '../../../assets/manuTimezoneIcon/ManuTimezoneIcon';
import { st, classes } from './TimezonePicker.st.css';
import WixStylesContext from '../../../context/wixStylesContext';
import usePrevious from '../../../hooks/usePrevious';
var TimezonePicker = function (_a) {
    var onTimezoneChange = _a.onTimezoneChange, timezone = _a.timezone, isTimezoneShown = _a.isTimezoneShown, _b = _a.className, className = _b === void 0 ? '' : _b, isMobilePopup = _a.isMobilePopup, locale = _a.locale;
    var t = useTranslation()[0];
    var _c = React.useState(tzUtils.getTimezones(locale)), timezones = _c[0], setTimezones = _c[1];
    var _d = React.useContext(WixStylesContext), timezoneFontSize = _d.timezoneFontSize, isWeekFontMoreTwantyFive = _d.isWeekFontMoreTwantyFive;
    var _e = React.useState(false), expanded = _e[0], setExpanded = _e[1];
    var _f = React.useState(tzUtils.getPlaceholder(timezone)), placeholder = _f[0], setPlaceholder = _f[1];
    var prevTimezone = usePrevious(timezone);
    React.useEffect(function () {
        if (prevTimezone !== timezone) {
            setPlaceholder(tzUtils.getPlaceholder(timezone));
        }
    }, [timezone]);
    var prevLocale = usePrevious(locale);
    React.useEffect(function () {
        if (prevLocale !== locale) {
            setTimezones(tzUtils.getTimezones(locale));
        }
    }, [locale]);
    var width = window.innerWidth;
    var label = width < 800 || timezoneFontSize >= 20 ? '' : t('Google_Calendar_Timezone');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: st(classes.root, { isTimezoneShown: isTimezoneShown, isMobilePopup: isMobilePopup, isWeekFontMoreTwantyFive: isWeekFontMoreTwantyFive }, className), tabIndex: 1 },
            isMobilePopup && React.createElement(ManuTimezoneIcon, null),
            React.createElement(FloatingDropdown, { forceContentElementVisibility: expanded, onChange: function (timezoneObj) {
                    setExpanded(false);
                    onTimezoneChange(timezoneObj.id);
                }, options: timezones, label: label, placeholder: placeholder, className: st(classes.Timezones, { isWeekFontMoreTwantyFive: isWeekFontMoreTwantyFive }), onExpandedChange: function () {
                    setExpanded(!expanded);
                } }))));
};
export default TimezonePicker;
//# sourceMappingURL=TimezonePicker.js.map